import { Component, OnInit, signal } from '@angular/core';
import { LoaderService } from '../services/loader.service';

@Component({
  selector: 'cert-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  standalone: false,
})
export class LoaderComponent implements OnInit {
  isLoading = signal(false);
  loaderMessage = signal<string | null>(null);
  constructor(private readonly loaderService: LoaderService) {}

  ngOnInit() {
    this.loaderService.loaderSignal$.subscribe((x) => {
      this.isLoading.set(x.isLoading);
      this.loaderMessage.set(x.loaderMessage);
    });
  }
}
